import * as map from "./map.js";
import * as activity from "./activity.js";
import * as uara from './uara';
import * as uaraTask from './uaraTask';
import * as letsBasketball from './letsBasketball';
import * as uploadFile from "./uploadFile.js";
import * as course from "./course.js";
import * as coach from "./coach.js";
import * as mpConfiguration from "./mpConfiguration.js";
import * as stores from "./stores.js";
import * as content from "./content.js";
import * as camp from "./camp.js";
import * as equipment from "./equipment.js";
import * as equipmentTask from './equipmentTask.js';
import * as popup from "./homePopupConfig";
import * as taskClock from "./taskClock";
import * as operation from "./operation";
import * as shortLink from "./shortLink";
import * as voteConfig from "./voteConfig";
import * as challengeMatch from "./challengeMatch";
import * as h5landing from './h5landing';
import * as running from './running';
import * as medal from './medal';
import * as lottery from './lottery';
import * as questions from './questions';
import * as channelPage from './channelPage';
import * as ecBannerAd from './ecBannerAd.js';
import * as benefits from './benefits.js';
import * as curriculumCollectionManagement from './curriculumCollectionManagement'
import * as quickFilterConfiguration from './quickFilterConfiguration'
export default {
  map,
  activity,
  uara,
  uaraTask,
  letsBasketball,
  uploadFile,
  course,
  coach,
  mpConfiguration,
  stores,
  content,
  camp,
  equipment,
  equipmentTask,
  popup,
  taskClock,
  operation,
  shortLink,
  voteConfig,
  challengeMatch,
  h5landing,
  running,
  medal,
  lottery,
  questions,
  channelPage,
  ecBannerAd,
  benefits,
  curriculumCollectionManagement,
  quickFilterConfiguration,
};
